import config from '../../config'

const state = {
  drawer: false,
  loginPage: false
}

const mutations = {
  setDrawer (state, payload) {
    state.drawer = payload
  },

  setLoginPage (state, isLoginPage) {
    state.loginPage = isLoginPage
  },

  setHttpBackend (state, newUrl) {
    config.BASE_BACKEND_URL = newUrl
  }
}

export default {
  state,
  mutations
}
